/* eslint-disable */
import { Space } from 'antd';
import { FilterDrawerWithTrigger } from 'components/molecules/filter-drawer';
import React from 'react';
import { excludedProjectFieldsForFilter } from 'utils/project-fields/constants';
import { useProjectFieldsAsFilterableFields } from 'utils/project-fields/use-project-fields-as-filterable-fields';

export const FilterDrawerDemo = () => {
  const { fields: allFields } = useProjectFieldsAsFilterableFields();

  const fields = allFields.filter(
    (x) => !excludedProjectFieldsForFilter.includes(x.fieldName),
  );

  const onSubmit = (filters) => {
    console.log('updated filter', filters);
  };
  return (
    <>
      <Space direction="vertical" size={300}>
        <FilterDrawerWithTrigger fields={fields} onSubmit={onSubmit} />
      </Space>
    </>
  );
};
